angular.module('satv.mediastats')
.factory('SubjectListModal', ['config', 'Modal', function(config, Modal) {
    'use strict';
    return {
        open: function(params, data) {
            return Modal.create(
                config.templateRoot + '/media/stats/templates/subject-list-modal',
                params,
                data
            );
        }
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/services/SubjectListModal.js